// extracted by mini-css-extract-plugin
module.exports = {"signup-mgm__promotion__description":"Promotion_signup-mgm__promotion__description___kYc3"};